module.exports = __webpack_public_path__ + "static/media/hot2.6b70bf2c.png";